
  import gql from 'graphql-tag';
  import productPromotionFragment from '~/apollo/fragments/productPromotionFragment';
  import annuityPlanScenariosQuery from '~/apollo/queries/product/annuityPlanScenario.gql';
  import annuityTooltips from '~/apollo/queries/product/tooltips/annuityTooltips';
  import commonProductDetailMixins from '~/mixins/commonProductDetailMixins.js';
  import productPromotionMixins from '~/mixins/productPromotionMixins.js';
  import productInsuranceNameMixins from '~/mixins/productInsuranceNameMixins';
  import productShortcutMixins from "~/mixins/productShortcutMixins.js";

  export default {
    name: 'ProductsDeferredAnnuitySavingsDetailPage',
    mixins: [commonProductDetailMixins, productPromotionMixins, productInsuranceNameMixins, productShortcutMixins],

    data() {
      return {
        annuityPlanScenarios: null,
        loading: 0,
        currentLocale: this.$normalizeLocale(this.$i18n.locale),
        category: this.$store.getters['productCompare/categroy']
      };
    },
    // page component definitions
    apollo: {
      $loadingKey: 'loading',
      annuityPlanScenarios: {
        query: gql`
          ${annuityPlanScenariosQuery}
          ${productPromotionFragment}
        `,
        prefetch: true,
        variables() {
          return {
            scenario_code: this.$route.params.slug,
            locale: this.currentLocale,
            show_stable_retirement: true,
          };
        },
      },
      annuityTooltips: {
        query: annuityTooltips,
        prefetch: true,
        variables() {
          return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
        },
        update(data) {
          return this.$normalizeStrapi(data.infoTooltip.data);
        },
      },
    },
    computed: {
      simpleItems() {
        if (this.annuityPlanScenarios?.data[0]) {
          const item = this.annuityPlanScenarios.data[0];
          let promotions = null;
          let promotion = null;
          let promotion_last_call = null;

          const planName = item.attributes.annuity_plan.data.attributes.annuity_plan_translations.data[0].attributes.name;
          let decoderCTALink = '';

          let mainCTA = this.getDecoderCTA(item, decoderCTALink);

          // check scenario level promo first , then plan level promotion
          if (item.attributes.product_promotions.data?.length > 0) {
            promotions = item.attributes.product_promotions.data;
          }
          if (item.attributes.annuity_plan.data.attributes.product_promotions.data?.length > 0) {
            promotions = item.attributes.annuity_plan.data.attributes.product_promotions.data;
          }

          if(promotions != null) {
            promotion = this.checkPromotionValid(promotions);
            promotion_last_call = this.checkPromotionLastCall(promotion);

            if (!promotion) {
              promotion = null;
            } else if (promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink) {
              decoderCTALink = promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink;

              mainCTA = this.getDecoderCTA(item, decoderCTALink);
            }
          }
          const getFulfilmentShortcut = this.getAnnuityFulfilmentShortcut(item.attributes)
          const shortcutfilfulmentRatio = getFulfilmentShortcut.fulfilmentRatio;
          //Insurer Fulfilment Score
          const insuranceCompanyStat = item.attributes.annuity_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.saving_input_insurer_fr_details.data;
          let insuranceCompanyStat6orAbove = [];
          let insuranceCompanyStatAll = [];

          if (insuranceCompanyStat.length > 0) {
            for (let x of insuranceCompanyStat) {
              if (x.attributes.fr_criteria_policyyear == 'All') {
                insuranceCompanyStatAll.push(x);
              }
              else if (x.attributes.fr_criteria_policyyear == '6 or above') {
                insuranceCompanyStat6orAbove.push(x);
              }
            }
          }

          const filteredTranslations = this.getFilteredTranslations(item.attributes.annuity_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
          .insurance_company_translations.data[0].attributes.localizations.data);


            const stable_retirement_result = item.attributes.annuity_plan_financial_details.data.filter(
                (fd) => {
                    if (item.attributes.income_term_end < 80) {
                      return fd.attributes.age === 75;
                    }
                    if (item.attributes.income_term_end <= 80 && item.attributes.income_term_end < 85) {
                      return fd.attributes.age === 80;
                    }
                    if (item.attributes.income_term_end >= 85) {
                      return fd.attributes.age === 85;
                    }
                    return fd.attributes.age === 85;
                  }
              )

            let overall_star = stable_retirement_result[0]?.attributes?.overall_star_stable_retirement;
            let  tenlife_score = stable_retirement_result[0]?.attributes?.stable_retirement_total_overall_score;
            let  g_return_ratio = stable_retirement_result[0]?.attributes?.g_return_ratio;
            let  p_return_ratio = stable_retirement_result[0]?.attributes?.p_return_ratio;
            let gbey = stable_retirement_result[0]?.attributes?.gbey;
            let pbey = stable_retirement_result[0]?.attributes?.pbey;
            let annual_premium = 7800;
            let g_initial_annual_income = (stable_retirement_result[0]?.attributes?.initial_income_gcv / stable_retirement_result[0]?.attributes?.discounted_tpp)*item?.attributes.tpp_display;
            let p_initial_annual_income = (stable_retirement_result[0]?.attributes?.initial_income_tot / stable_retirement_result[0]?.attributes?.discounted_tpp)*item?.attributes.tpp_display;

          return {
            // ****** SUMMARY ******
            premium_term: item.attributes.premium_term,
            income_term_start: item.attributes.income_term_start,
            income_term: item.attributes.income_term,
            // overall_star_savings: item.attributes.overall_star_savings,
            overall_star: overall_star,
            gbey: gbey,
            pbey: pbey,
            g_return_ratio,
            p_return_ratio,
            tpp_display: item.attributes.tpp_display,

            tenlife_score: this.$formatScore(tenlife_score),
            shortcutfilfulmentRatio: shortcutfilfulmentRatio,
            // annuity_savings_score: item.attributes.annuity_savings_score,
            // plan
            plan_name: planName,
            // // insurer
            insurer_name_first:
              item.attributes.annuity_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                .insurance_company_translations.data[0].attributes.name,
            insurer_name_second:
              filteredTranslations[0].attributes.name,
            insurer_logo:
              item.attributes.annuity_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.logo,
            insurer_code:
              item.attributes.annuity_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.code,
            // financial details
            // savings_result: item.attributes.annuity_plan_financial_details.data.filter(item => item.attributes.age === 60),
            first_income_result: item.attributes.annuity_plan_financial_details.data.filter(
              (e) => e.attributes.age === item.attributes.income_term_start
            ),

            // ****** 10Life Scenario ******
            currency: item.attributes.currency.data.attributes.currency_translations.data[0].attributes,
            currency_code: item.attributes.currency.data.attributes.code,

            annual_premium,
            total_premium: item.attributes.total_premium,
            g_initial_annual_income,
            p_initial_annual_income,
            // g_income_yearone: item.attributes.g_income_yearone,
            // p_income_yearone_base: item.attributes.p_income_yearone_base,
            // g_per_income_yearone_base: item.attributes.g_per_income_yearone_base,

            // ****** Product Facts ******
            issue_age_from: item.attributes.issue_age_from,
            issue_age_to: item.attributes.issue_age_to,

            // ****** Guaranteed Return ******
            income_term_end: item.attributes.income_term_end,
            // ****** Projected Return ******

            // ****** Early Surrender Coverage ******

            product_promotion: promotion,
            promotion_last_call: promotion_last_call,

            main_cta: mainCTA,

            annuity_plan_financial_details: item.attributes.annuity_plan_financial_details,
            scenarioId: item.id,

            // ***** insurer fulfillment ratio *****
            data_points_all: insuranceCompanyStatAll[0].attributes.fr_count,
          data_points_6_or_above: insuranceCompanyStat6orAbove[0].attributes.fr_count,
          average_fr_6_or_above: insuranceCompanyStat6orAbove[0]?.attributes.fr_average,
          average_fr_all: insuranceCompanyStatAll[0]?.attributes.fr_average,
          proportion_of_fr_6_or_above: 1 - (insuranceCompanyStat6orAbove[0]?.attributes.fr_freq_le70pct),
          proportion_of_fr_all: 1 - (insuranceCompanyStatAll[0]?.attributes.fr_freq_le70pct),
          };
        }
        return null;
      },

      product() {
        if (!this.simpleItems) return null;

        return {
          highlightSection: {
            scenarioCode: this.simpleItems.scenario_code,
            scenarioId: this.simpleItems.scenarioId,
            showFiveStarBadge: this.simpleItems.overall_star,
            productName: this.simpleItems.plan_name,
            insuranceCompany: {
              name: this.simpleItems.insurer_name_first + ' | ' + this.simpleItems.insurer_name_second,
              code: this.simpleItems.insurer_code,
              logoSrc: this.simpleItems.insurer_logo?.data?.attributes?.url,
              logoAlt: this.simpleItems.insurer_name_first,
            },
            userRating: {
              score: this.simpleItems.overall_star_savings,
              numberOfRatedUser: '0',
            },
            tenlifeScore: {
              score: parseFloat(this.simpleItems.tenlife_score),
              description: this.$t('products.annuity.as_savingsAnnuityScore'),
              toolTipHtml: this.getTooltipContentByKey('tl_stableAnnuityScore'),
            },
            features: [
              {
                text: this.simpleItems.premium_term + this.$t('products.yearPremium'),
                type: 'default',
              },
              {
                text:
                  this.$formatAge(this.currentLocale, this.simpleItems.income_term_start, this.$t('products.ageUnit')) +
                  this.$t('products.annuity.as_annuityStart'),
                type: 'default',
              },
              {
                text:
                  this.simpleItems.income_term === 999
                    ? this.$t('products.annuity.ai_wholelife')
                    : this.simpleItems.income_term + this.$t('products.yearAnnuity'),
                type: 'default',
              },
            ],
            keyItems: [
              {
                value: this.$formatPrice(this.simpleItems.g_initial_annual_income),
                key: this.$t('products.annuity.as_guaranteedInitialAnnualIncome'),
                topSubText: this.simpleItems.currency_code,
                toolTipHtml: '',
                symbolValue: '',
                originalValue: '',
              },
              {
                value: this.$formatPercentage(this.simpleItems.g_return_ratio),
                key: this.$t('products.annuity.ar_guaranteedReturnRatioatAgeNum').replace('$num', this.simpleItems.income_term_end > 85 ? 85 : this.simpleItems.income_term_end),
                topSubText: '',
                toolTipHtml: this.simpleItems.income_term_end === 75 ? this.getTooltipContentByKey('ar_guaranteedReturnRatioatAge75') : this.getTooltipContentByKey('ar_guaranteedReturnRatioatAge85'),
                symbolValue: '',
                originalValue: '',
              },
              {
                value: this.$formatPercentage(this.simpleItems.p_return_ratio),
                key: this.$t('products.annuity.ar_projectedReturnRatioatAgeNum').replace('$num', this.simpleItems.income_term_end > 85 ? 85 : this.simpleItems.income_term_end),
                topSubText: '',
                toolTipHtml: this.simpleItems.income_term_end === 75 ? this.getTooltipContentByKey('ar_projectedReturnRatioatAge75') : this.getTooltipContentByKey('ar_projectedReturnRatioatAge85'),
                symbolValue: '',
                originalValue: '',
              },
              {
                value: this.simpleItems.gbey,
                key: this.$t('products.annuity.as_guaranteedBreakevenYear'),
                topSubText: '',
                toolTipHtml: '',
                symbolValue: '',
                originalValue: '',
              },
            ],
            mainButtonCTA: this.simpleItems.main_cta,
            showShortcutFulfilmentRatio: this.simpleItems.shortcutfilfulmentRatio,
          },
          detailSection: {
            details: [
              {
                id: 0,
                sectionTitle: this.$t('products.annuity.as_10LifeScenario'),
                keyValues: [
                {
                    key: this.$t('products.annuity.as_savingsAnnuityScore'),
                    value: parseFloat(this.simpleItems.tenlife_score) + ' / 10',
                    keyToolTipHtml: '',
                    expandableKeyValues: [],
                  },
                  {
                    key: this.$t('products.annuity.as_currency'),
                    value: this.getCurrency(this.simpleItems.currency),
                    keyToolTipHtml: '',
                    expandableKeyValues: [],
                  },
                  {
                    key: this.$t('products.annuity.as_firstYearPremium'),
                    value: this.simpleItems.currency_code + ' ' + this.$formatPrice(this.simpleItems.annual_premium),
                    keyToolTipHtml: '',
                    expandableKeyValues: [],
                  },
                  {
                    key: this.$t('products.annuity.as_premiumTerm'),
                    value: this.$formatPrice(this.simpleItems.premium_term),
                    keyToolTipHtml: '',
                    expandableKeyValues: [],
                  },
                  {
                    key: this.$t('products.annuity.as_totalPremiumPaid'),
                    value: this.simpleItems.currency_code + ' ' + this.$formatPrice(this.simpleItems.tpp_display),
                    keyToolTipHtml: '',
                    expandableKeyValues: [],
                  },
                  {
                    key: this.$t('products.annuity.as_guaranteedBenefitPerPremiumPaidAtMaturity'),
                    value:  this.$formatPercentage(this.simpleItems.g_return_ratio),
                    keyToolTipHtml: '',
                    expandableKeyValues: [],
                  },
                  {
                    key: this.$t('products.annuity.as_incomeTerm'),
                    value: this.simpleItems.income_term,
                    keyToolTipHtml: '',
                    expandableKeyValues: [],
                  },
                  {
                    key: this.$t('products.annuity.as_guaranteedInitialAnnualIncome'),
                    value: this.simpleItems.currency_code + ' ' + this.$formatPrice(this.simpleItems.g_initial_annual_income),
                    keyToolTipHtml: '',
                    expandableKeyValues: [],
                  },
                  {
                    key: this.$t('products.annuity.as_projectedInitialAnnualIncome'),
                    value: this.simpleItems.currency_code + ' ' + this.$formatPrice(this.simpleItems.p_initial_annual_income),
                    keyToolTipHtml: '',
                    expandableKeyValues: [],
                  },
                ],
              },
              {
                id: 1,
                sectionTitle: this.$t('products.annuity.as_guaranteedReturn'),
                keyValues: [
                {
                    key: this.$t('products.annuity.as_guaranteedBreakevenYear'),
                    value: this.simpleItems.gbey,
                    keyToolTipHtml: '',
                    expandableKeyValues: [],
                },
                {
                    key: this.$t('products.annuity.as_guaranteedInternalRateofReturnIRR'),
                    value: '',
                    keyToolTipHtml: '',
                    expandableKeyValues: [],
                    },
                    {
                      ...this.gSurrenderData(this.simpleItems, 75),
                      handleDuplicatedKey: 0,
                    },
                    {
                      ...this.gSurrenderData(this.simpleItems, 85),
                      handleDuplicatedKey: 0,
                    },
                {
                  key: this.$t('products.annuity.as_guaranteedInternalRateofReturnIRRWith17TaxSavings'),
                  value: '',
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                  },
                  {
                    ...this.gSurrenderDataTax(this.simpleItems, 75),
                    handleDuplicatedKey: 1
                  },
                  {
                    ...this.gSurrenderDataTax(this.simpleItems, 85),
                    handleDuplicatedKey: 1
                  },

                this.gIncomeData(
                  this.simpleItems,
                  60,
                  69,
                  this.$t('products.annuity.ar_totalGuaranteedIncomeAge6069'),
                  this.$t('products.annuity.ar_totalGuaranteedIncomeAge')
                ),
                this.gIncomeData(
                  this.simpleItems,
                  70,
                  79,
                  this.$t('products.annuity.ar_totalGuaranteedIncomeAge7079'),
                  this.$t('products.annuity.ar_totalGuaranteedIncomeAge')
                ),
                this.gIncomeData(
                  this.simpleItems,
                  80,
                  89,
                  this.$t('products.annuity.ar_totalGuaranteedIncomeAge8089'),
                  this.$t('products.annuity.ar_totalGuaranteedIncomeAge')
                ),
                this.gIncomeData(
                  this.simpleItems,
                  90,
                  99,
                  this.$t('products.annuity.ar_totalGuaranteedIncomeAge9099'),
                  this.$t('products.annuity.ar_totalGuaranteedIncomeAge')
                ),
                ],
              },
              {
                id: 2,
                sectionTitle: this.$t('products.annuity.as_projectedReturn'),
                keyValues: [
                  {
                    key: this.$t('products.annuity.as_projectedBreakevenYear'),
                    value: this.simpleItems.pbey,
                    keyToolTipHtml: '',
                    expandableKeyValues: [],
                  },
                  {
                    key: this.$t('products.annuity.as_projectedInternalRateofReturnIRR'),
                    value: '',
                    keyToolTipHtml: '',
                    expandableKeyValues: [],
                    },
                    {
                      ...this.pSurrenderData(this.simpleItems, 75),
                      handleDuplicatedKey: 0
                    },
                    {
                      ...this.pSurrenderData(this.simpleItems, 85),
                      handleDuplicatedKey: 0
                    },
                {
                  key: this.$t('products.annuity.as_projectedInternalRateofReturnIRRwith17TaxSavings'),
                  value: '',
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                  },
                  {
                    ...this.pSurrenderDataTax(this.simpleItems, 75),
                    handleDuplicatedKey: 1
                  },
                  {
                    ...this.pSurrenderDataTax(this.simpleItems, 85),
                    handleDuplicatedKey: 1
                  },

                this.pIncomeData(
                  this.simpleItems,
                  60,
                  69,
                  this.$t('products.annuity.ar_totalProjectedIncomeAge6069'),
                  this.$t('products.annuity.ar_totalProjectedIncomeAge')
                ),
                this.pIncomeData(
                  this.simpleItems,
                  70,
                  79,
                  this.$t('products.annuity.ar_totalProjectedIncomeAge7079'),
                  this.$t('products.annuity.ar_totalProjectedIncomeAge')
                ),
                this.pIncomeData(
                  this.simpleItems,
                  80,
                  89,
                  this.$t('products.annuity.ar_totalProjectedIncomeAge8089'),
                  this.$t('products.annuity.ar_totalProjectedIncomeAge')
                ),
                this.pIncomeData(
                  this.simpleItems,
                  90,
                  99,
                  this.$t('products.annuity.ar_totalProjectedIncomeAge9099'),
                  this.$t('products.annuity.ar_totalProjectedIncomeAge')
                ),
                ],
              },
              {
                id: 3,
                sectionTitle: this.$t('products.annuity.as_earlySurrenderCoverage'),
                keyValues: [
                  {
                    key: this.$t('products.annuity.ar_surrenderatThe10thPolicyYear'),
                    value: this.$formatPercentageDP(
                      this.getEarlySurrenderGuaranteedCoverage(this.simpleItems, 10),
                      1
                    ),
                    keyToolTipHtml: '',
                    expandableKeyValues: [],
                  },
                  {
                    key: this.$t('products.annuity.ar_surrenderatThe20thPolicyYear'),
                    value: this.$formatPercentageDP(
                      this.getEarlySurrenderGuaranteedCoverage(this.simpleItems, 20),
                      1
                    ),
                    keyToolTipHtml: '',
                    expandableKeyValues: [],
                  },
                ],
              },
              {
                id: 4,
                sectionTitle: this.$t('products.longSavings.ls_insurerFulfillmentRatios'),
                keyValues : [
                  {
                    key: this.$t('products.longSavings.ls_fulfillmentRatioStatisticsPolicyYear6orAbove'),
                    value: '',
                    keyToolTipHtml: '',
                    expanded: false,
                    expandableKeyValues: [
                      {
                        key: this.$t('products.longSavings.ls_dataPoint'),
                        value: this.simpleItems.data_points_6_or_above == 0 ? "0" : this.simpleItems.data_points_6_or_above,
                      },
                      {
                        key: this.$t('products.longSavings.ls_averageFulfillmentRatiosPolicyYear6orAbove'),
                        value: this.simpleItems.data_points_6_or_above == 0 ? this.$t('not_applicable') : this.$formatPercentageDP(this.simpleItems.average_fr_6_or_above, 0),
                      },
                      {
                        key: this.$t('products.longSavings.ls_proportionOfFulfillmentRatiosWhichAreHigherThan70'),
                        value: this.simpleItems.data_points_6_or_above == 0 ? this.$t('not_applicable') : this.$formatPercentageDP(this.simpleItems.proportion_of_fr_6_or_above, 0),
                      },
                    ],
                  },
                  {
                    key: this.$t('products.longSavings.ls_fulfillmentRatioStatisticsAllPolicyYear'),
                    value: '',
                    keyToolTipHtml: '',
                    expanded: false,
                    expandableKeyValues: [
                      {
                        key: this.$t('products.longSavings.ls_dataPoint'),
                        value: this.simpleItems.data_points_all == 0 ? "0" : this.simpleItems.data_points_all,
                      },
                      {
                        key: this.$t('products.longSavings.ls_averageFulfillmentRatios'),
                        value: this.simpleItems.data_points_all == 0 ? this.$t('not_applicable') : this.$formatPercentageDP(this.simpleItems.average_fr_all, 0),
                      },
                      {
                        key: this.$t('products.longSavings.ls_proportionOfFulfillmentRatiosWhichAreHigherThan70'),
                        value: this.simpleItems.data_points_all == 0 ? this.$t('not_applicable') : this.$formatPercentageDP(this.simpleItems.proportion_of_fr_all, 0),
                      },
                    ],
                  },
                ]
              }
            ],
            promotion: {
              category:
                this.simpleItems.product_promotion?.attributes?.product_promotion_translations?.data[0].attributes
                  ?.PromotionCategory,
              title:
                this.simpleItems.product_promotion?.attributes?.product_promotion_translations?.data[0].attributes
                  ?.PromotionTitle,
              ctaButtonLink:
                this.simpleItems.product_promotion?.attributes?.product_promotion_translations?.data[0].attributes
                  ?.CTAButtonLink,
              ctaButtonText:
                this.simpleItems.product_promotion?.attributes?.product_promotion_translations?.data[0].attributes
                  ?.CTAButtonText,
              promotionId: this.simpleItems.product_promotion?.id,
              scenarioId: this.simpleItems.scenarioId,
              lastCall: this.simpleItems.promotion_last_call

            },
          },
        };
      },
    },

    methods: {
      financial_details(annuityPlanFinancialDetails, age) {
        return annuityPlanFinancialDetails.data.filter((item) => item.attributes.age === age)[0];
      },
      financial_details_end_of_policy_year(annuityPlanFinancialDetails, year) {
        return annuityPlanFinancialDetails.data.filter((item) => item.attributes.end_of_policy_year === year)[0];
      },

      financial_details_year(annuityPlanFinancialDetails, year) {
        return annuityPlanFinancialDetails.data.filter((item) => item.attributes.year === year)[0];
      },

      getCurrency(curr) {
        if (this.currentLocale === 'zh-Hant-HK') {
          return curr.text;
        } else {
          return curr.localizations.data[0].attributes.text;
        }
      },

      getCurrencyCode(curr) {
        if (this.currentLocale === 'zh-Hant-HK') {
          return curr.code;
        } else {
          return curr.localizations.data[0].attributes.code;
        }
      },

      get_g_annual_income(item, age) {
        const fd = this.financial_details(item.annuity_plan_financial_details, age);
        const income_gcv = fd?.attributes?.income_gcv;
        const discounted_tpp = fd?.attributes?.discounted_tpp;
        const tpp_display = item?.tpp_display;
        return (income_gcv/discounted_tpp)*tpp_display;
      },
      get_p_annual_income(item, age) {
        const fd = this.financial_details(item.annuity_plan_financial_details, age);
        const income_tot = fd?.attributes?.income_tot;
        const discounted_tpp = fd?.attributes?.discounted_tpp;
        const tpp_display = item?.tpp_display;

        return (income_tot/discounted_tpp)*tpp_display;
      },

      gIncomeData(item, fromAge, toAge, lblGroup, lblItem) {
        const sumData = (fromAge, toAge) => {
          let tmpSum = 0;
          for (let i = fromAge; i < toAge + 1; i++) {
            const tmpIncome =
            this.get_g_annual_income(item, i) > 0
                ? parseFloat(this.get_g_annual_income(item, i))
                : 0;
            tmpSum = tmpSum + tmpIncome;
          }

          return tmpSum;
        };

        const expandableArray = (fromAge, toAge, lblItem) => {
          // eslint-disable-next-line
          let tmpArray = [];
          let tmpItem = [];
          for (let i = fromAge; i < toAge + 1; i++) {
            tmpItem = [
              {
                key: lblItem.replace('$num', i),
                value:
                  item.currency_code +
                  ' ' +
                  this.$formatPrice(
                    this.get_g_annual_income(item, i)
                      ?  this.get_g_annual_income(item, i)
                      : 0
                  ),
                keyToolTipHtml: '',
                expandableKeyValues: [],
              },
            ];
            tmpArray = tmpArray.concat(tmpItem);
          }
          return tmpArray;
        };

        return {
          key: lblGroup,
          value: item.currency_code + ' ' + this.$formatPrice(sumData(fromAge, toAge)),
          keyToolTipHtml: '',
          expanded: false,
          expandableKeyValues: expandableArray(fromAge, toAge, lblItem),
        };
      },

      gSurrenderData(item, year) {
        const checkValue = this.financial_details(item.annuity_plan_financial_details, year)?.attributes.surrender_discounted_non_tax_s_girr
        return {
          key: this.$t('products.annuity.ar_surrenderatAge').replace('$num', year),
          value: checkValue ?
              this.$formatPercentage(checkValue)
              :
              this.$t('products.annuity.as_annuityEnd'),
          // value: this.$formatPercentage(
          //       this.financial_details_end_of_policy_year(item.annuity_plan_financial_details, year)?.attributes.surrender_discounted_non_tax_s_girr
          //     ),
          keyToolTipHtml: '',
          expandableKeyValues: [],
        };
      },

      gSurrenderDataTax(item, year) {
        const checkValue = this.financial_details(item.annuity_plan_financial_details, year)?.attributes.surrender_discounted_tax_s_girr;
        return {
          key: this.$t('products.annuity.ar_surrenderatAge').replace('$num', year),
          // value:
          // this.$formatPercentage(this.financial_details_end_of_policy_year(item.annuity_plan_financial_details, year)?.attributes.surrender_discounted_tax_s_girr),
          value:
            checkValue
              ? this.$formatPercentage(checkValue)
              :
              this.$t('products.annuity.as_annuityEnd'),
          keyToolTipHtml: '',
          expandableKeyValues: [],
        };
      },

      getEarlySurrenderGuaranteedCoverage(item, year) {
        return this.financial_details_end_of_policy_year(item.annuity_plan_financial_details, year)?.attributes.g_return_ratio;
      },

      pIncomeData(item, fromAge, toAge, lblGroup, lblItem) {
        const sumData = (fromAge, toAge) => {
          let tmpSum = 0;
          for (let i = fromAge; i < toAge + 1; i++) {
            const tmpIncome =
            this.get_p_annual_income(item, i) > 0
                ? parseFloat(
                  this.get_p_annual_income(item, i)
                )
                : 0;
            tmpSum = tmpSum + tmpIncome;
          }

          return tmpSum;
        };

        const expandableArray = (fromAge, toAge, lblItem) => {
          // eslint-disable-next-line
          let tmpArray = [];
          let tmpItem = [];
          for (let i = fromAge; i < toAge + 1; i++) {
            tmpItem = [
              {
                key: lblItem.replace('$num', i),
                value:
                  item.currency_code +
                  ' ' +
                  this.$formatPrice(
                    this.get_p_annual_income(item, i)
                      ? this.get_p_annual_income(item, i)
                      : 0
                  ),
                keyToolTipHtml: '',
                expandableKeyValues: [],
              },
            ];
            tmpArray = tmpArray.concat(tmpItem);
          }
          return tmpArray;
        };

        return {
          key: lblGroup,
          value: item.currency_code + ' ' + this.$formatPrice(sumData(fromAge, toAge)),
          keyToolTipHtml: '',
          expanded: false,
          expandableKeyValues: expandableArray(fromAge, toAge, lblItem),
        };
      },

      pSurrenderData(item, year) {
        const checkValue = this.financial_details(item.annuity_plan_financial_details, year)?.attributes.surrender_discounted_non_tax_s_pirr
        return {
          key: this.$t('products.annuity.ar_surrenderatAge').replace('$num', year),
          value:
          checkValue
              ? this.$formatPercentage(checkValue)
              : this.$t('products.annuity.as_annuityEnd'),
          keyToolTipHtml: '',
          expandableKeyValues: [],
        };
      },

      pSurrenderDataTax(item, year) {
        const checkValue = this.financial_details(item.annuity_plan_financial_details, year)?.attributes.surrender_discounted_tax_s_pirr
        return {
          key: this.$t('products.annuity.as_surrenderatage').replace('$num', year),
          value:
          checkValue
              ? this.$formatPercentage(checkValue)
              : this.$t('products.annuity.as_annuityEnd'),
          keyToolTipHtml: '',
          expandableKeyValues: [],
        };
      },

      getTooltipContentByKey(mKey) {
        return this.annuityTooltips?.Annuity?.ToolTips?.find(({ Key }) => Key === mKey)?.ToolTipContent ?? '';
      },

      getDecoderCTA(item, promotionCTALink) {
        const planName = item.attributes.annuity_plan.data.attributes.annuity_plan_translations.data[0].attributes.name;
        const insurer = item.attributes.annuity_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name;
        const decoderCTAWhatsappLink = this.$generateWhatsappCTALink(this.$t('products.annuity.as_categoryName'), insurer, planName);
        const showCTA = item.attributes.show_cta;
        const saleable = item.attributes.annuity_plan.data.attributes.saleable;
        const productWebsite = item.attributes.annuity_plan.data.attributes.annuity_plan_translations.data[0].attributes.product_website;

        if (!showCTA) return null;

        if (saleable) {
          return {
            text: this.$t('products.purchase_now'),
            link:
              process.env.SALES_EXTERNAL_URL +
              '/' +
              (this.currentLocale === 'en' ? 'en' : 'tc') +
              '/purchase?id=' +
              item.attributes.scenario_code
          };
        } else if (promotionCTALink) {
          return {
            text: this.$t('products.purchase_now'),
            link: promotionCTALink,
          };
        } else if (productWebsite) {
          return {
            text: this.$t('products.product_website'),
            link: productWebsite,
            type: 'product-website',
          };
        } else {
          return {
            text: '',
            link: decoderCTAWhatsappLink,
          };
        }
      },
    },
  };
  